import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export function CtaSection() {
  return (
    <div className="bg-gray-800 py-24">
      <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl text-white mb-6">
          Ready to fast-track your connectivity ?
        </h2>
        <p className="text-xl text-gray-300 mb-12">
          Join cutting-edge businesses that trust our platform to power their operations.
        </p>
        <Link
          to="/signup"
          className="inline-flex items-center px-8 py-4 bg-[#3C7CD6] hover:bg-[#4A8DE0] text-white text-lg font-medium rounded-lg transition-colors"
        >
          Get Started Now
          <ArrowRight className="ml-2 h-5 w-5" />
        </Link>
      </div>
    </div>
  );
}